export default __webpack_public_path__ + "static/media/backgroundCustomer.7280b672.png";